<dx-popup
    class="popup"
    [width]="isPhone ? isPhoneLandscape ? '90vw' : '100%' : 680"
    [height]="'90vh'"
    [showTitle]="true"
    [dragEnabled]="true"
    [closeOnOutsideClick]="false"
    [showCloseButton]="false"
    [maxHeight]="'90vh'"
    [(visible)]="popupVisible"
>
    <dxi-toolbar-item location="before">
        <h3 fxShow fxHide.lt-md style="margin: 5px 0">
            Search Patient
        </h3>
        <h4 fxShow fxHide.gt-sm style="margin: 5px 0">
            Search Patient
        </h4>
    </dxi-toolbar-item>
    <dxi-toolbar-item location="before">
        <dx-load-indicator
            height="20"
            width="20"
            [(visible)]="isLoading"
            style="margin-left: 8px; margin-top: 4px;"
        ></dx-load-indicator>
    </dxi-toolbar-item>

    <dxi-toolbar-item location="after">
        <dx-drop-down-box fxShow fxHide.xs
                          valueExpr="id"
                          *ngIf="recentAvailable"
                          placeholder="Recent Patients"
                          [dataSource]="recentPatientService.getRecentPatients()"
                          (onOpened)="resizeDropDown()"
        >
            <div *dxTemplate="let data of 'content'">
                    <ng-container
                        *ngTemplateOutlet="patientsGrid; context: { dataSource: recentPatients }"></ng-container>
            </div>
        </dx-drop-down-box>
    </dxi-toolbar-item>
    <dxi-toolbar-item location="after" fxShow fxHide.xs>
        <dx-button text="Clear" (click)="clear()"></dx-button>
    </dxi-toolbar-item>
    <dxi-toolbar-item location="after" fxShow fxHide.xs [visible]="role !== 'Physician' && role !== 'Patient'">
        <dx-button text="New Patient" [disabled]="!searched" (click)="newPatient()"></dx-button>
    </dxi-toolbar-item>
    <dxi-toolbar-item location="after">
        <dx-button
            text="Search"
            (click)="submitSearch()"
            [disabled]="patientDialogForm.invalid && !fromSearch"
        ></dx-button>
    </dxi-toolbar-item>
    <dxi-toolbar-item location="after" fxShow fxHide.xs>
        <dx-button text="Close" (click)="close()"></dx-button>
    </dxi-toolbar-item>

    <dxi-toolbar-item fxShow fxHide.gt-xs widget="dxDropDownButton" location="after">
        <dx-drop-down-button
            style="height: 26px"
            [visible]="isPhone"
            [splitButton]="false"
            [showArrowIcon]="false"
            [dropDownOptions]="{ width: 100 }"
            icon="overflow"
            [items]="buttons"
            displayExpr="name"
            keyExpr="id"
            (onItemClick)="onItemClick($event)"
            (onContentReady)="dropdownButtonReady($event)">
        </dx-drop-down-button>
    </dxi-toolbar-item>

    <div *dxTemplate="let data of 'content'" [ngStyle.xs]="{height: '100%'}">
        <form [formGroup]="patientDialogForm" [ngStyle.xs]="{height: '100%'}" style="height: inherit">
            <div fxLayout="column" fxLayout.xs="column" fxLayout.sm="row" style="height: inherit">
                <div id="form"
                     [ngStyle.sm]="{width: '39%', 'padding-right': '3px', height: '100% !important;'}"
                     style="width: 100%; height: auto" class="filters" fxLayout="row"
                     fxLayoutAlign="center">
                    <div class="ocl-dialog-content" fxLayout="column" fxLayoutAlign="start space-between">
                        <p class="ocl-danger ocl-dialog-info">Search before entering a new patient.</p>
                        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start"
                             fxLayoutAlign="start start"
                             [ngStyle.lt-md]="{width: '100%'}">
                            <div class="dx-fieldset">
                                <div class="dx-field">
                                    <div class="dx-field-label">
                                        Last Name <span *ngIf="!fromSearch"
                                                        class="ocl-required-indicator">*</span>
                                    </div>
                                    <div class="dx-field-value">
                                        <dx-text-box
                                            #lastNameTextBox
                                            class="uppercase"
                                            formControlName="lastName"
                                        >
                                            <dx-validator validationGroup="patientDialog">
                                                <dxi-validation-rule *ngIf="!fromSearch"
                                                                     type="required"
                                                                     message="Last name is required"
                                                ></dxi-validation-rule>
                                            </dx-validator>
                                        </dx-text-box>
                                    </div>
                                </div>
                                <div class="dx-field">
                                    <div class="dx-field-label">
                                        First Name <span *ngIf="!fromSearch"
                                                         class="ocl-required-indicator">*</span>
                                    </div>
                                    <div class="dx-field-value">
                                        <dx-text-box formControlName="firstName" class="uppercase">
                                            <dx-validator validationGroup="patientDialog">
                                                <dxi-validation-rule *ngIf="!fromSearch"
                                                                     type="required"
                                                                     message="First name is required"
                                                ></dxi-validation-rule>
                                            </dx-validator>
                                        </dx-text-box>
                                    </div>
                                </div>
                            </div>
                            <div fxFlex.sm="49%" class="dx-fieldset">
                                <div class="dx-field">
                                    <div class="dx-field-label">
                                        DOB
                                    </div>
                                    <div class="dx-field-value">
                                        <dx-date-box formControlName="dob" type="date" [max]="today" [min]="firstDate"
                                                     style="min-height: 24px"
                                                     (onContentReady)="onBirthDateReady($event)">
                                        </dx-date-box>
                                    </div>
                                </div>
                                <div class="dx-field" fxShow fxHide.lt-md>
                                    <div class="dx-field-label">SSN</div>
                                    <div class="dx-field-value">
                                        <dx-text-box formControlName="ssn" mask="000-00-0000"
                                                     [maskRules]="ssnMaskRule">
                                        </dx-text-box>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div style="height: calc(80vh - 75px - 59px - 32px);"
                     [ngStyle.sm]="{width: '60%', height: '100%'}"
                     [ngStyle.xs]="{height: 'calc(80vh - 120px - 59px - 32px)'}">
                    <ng-container
                        *ngTemplateOutlet="patientsGrid;context: { dataSource: searchedPatients.value }"></ng-container>
                </div>
            </div>
        </form>
    </div>

</dx-popup>

<ng-template #patientsGrid let-dataSource="dataSource">
    <dx-data-grid [dataSource]="dataSource"
                  [showRowLines]="true"
                  (onRowClick)="rowClick($event)"
                  [height]="'100%'"
                  [showBorders]="true"
                  [hoverStateEnabled]="true"
                  [highlightChanges]="true"
                  [columnAutoWidth]="true"
                  [allowColumnResizing]="true"
                  [columnHidingEnabled]="isPhone || isPhoneLandscape || isTablet"
                  style="min-width: 250px !important;">
        <dxo-remote-operations [filtering]="true" [sorting]="true" [paging]="true"></dxo-remote-operations>
        <dxi-column caption="Patient Id" dataField="code"
                    [hidingPriority]="isPhone || isPhoneLandscape || isTablet ? 1 : -1"></dxi-column>
        <dxi-column caption="Last Name" dataField="lastName"
                    [hidingPriority]="isPhone || isPhoneLandscape || isTablet ? 4 : -1"></dxi-column>
        <dxi-column caption="First Name" dataField="firstName"
                    [hidingPriority]="isPhone || isPhoneLandscape || isTablet ? 3 : -1"></dxi-column>
        <dxi-column caption="Birth Date" dataField="birthDate" dataType="date"
                    [hidingPriority]="isPhone || isPhoneLandscape || isTablet ? 2 : -1"></dxi-column>
        <dxi-column caption="SSN" dataField="ssn"
                    [hidingPriority]="isPhone || isPhoneLandscape || isTablet ? 0 : -1"></dxi-column>
    </dx-data-grid>
</ng-template>

<app-client-physician-selector-dialog
    [subtitle]="subtitle"
    [popupVisible]="clientPopupVisible"
    [selectedPatient]="selectedPatient"
    (closeEvent)="closeDialog($event)"
></app-client-physician-selector-dialog>
